const FEATURES = [
  {
    id: 1,
    title: '高清画质',
    desc: '支持从流畅到4K超清的多档画质切换，每一帧都细腻真实，带来影院级视觉享受。所有视频源经过专业转码优化，画质与流畅度完美平衡。',
    icon: 'ri-4k-line',
  },
  {
    id: 2,
    title: '流畅播放',
    desc: '多线CDN智能分发技术，自动匹配最优播放节点。全球加速网络覆盖，无论身处何地都能享受极速加载、不卡顿不缓冲的播放体验。',
    icon: 'ri-speed-line',
  },
  {
    id: 3,
    title: '海量内容',
    desc: '超过10万部影视资源库，涵盖电影、剧集、综艺、动漫、纪录片等全品类。内容团队每日更新，热门大片第一时间同步上线，追剧不等待。',
    icon: 'ri-stack-line',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">为什么选择我们</h2>
          <p className="text-sm text-foreground-500 mt-2">51视频的核心优势，为您带来更好的观影体验</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {FEATURES.map((feature) => (
            <div
              key={feature.id}
              className="text-center bg-background-50 border border-background-200/60 rounded-xl p-6 md:p-8 hover:border-primary-200 transition-all group cursor-pointer"
            >
              <span className="w-16 h-16 flex items-center justify-center bg-primary-50 rounded-2xl mx-auto mb-5 group-hover:bg-primary-100 transition-colors">
                <i className={`${feature.icon} text-2xl text-primary-600`}></i>
              </span>
              <h3 className="text-lg font-bold text-foreground-950 mb-3">{feature.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}